import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function QuestionCircleIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M12.938 16.875a.938.938 0 1 1-1.875 0 .938.938 0 0 1 1.875 0M12 6.938c-1.969 0-3.563 1.429-3.563 3.188v.375a.563.563 0 1 0 1.125 0v-.375c0-1.137 1.093-2.063 2.438-2.063s2.438.925 2.438 2.063-1.093 2.063-2.438 2.063a.563.563 0 0 0-.563.563v.75a.563.563 0 1 0 1.125 0v-.226c1.698-.242 3-1.562 3-3.149 0-1.758-1.594-3.188-3.563-3.188M21.563 12A9.563 9.563 0 1 1 12 2.438 9.574 9.574 0 0 1 21.563 12m-1.125 0A8.438 8.438 0 1 0 12 20.438 8.445 8.445 0 0 0 20.438 12"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
